import React from "react";
import { useSelector } from "react-redux";

import FordNrOfProjectsStages from "modules/reporting/fordReports/kpis/sections/nrOfProjectsStages";
import FordProjectNumbers from "modules/reporting/fordReports/kpis/sections/projectNumbers";
import FordClientPlants from "modules/reporting/fordReports/kpis/sections/clientPlants";
import FordInnovationCategory from "modules/reporting/fordReports/kpis/sections/innovationCategory";
import FordNrOfReplications from "modules/reporting/fordReports/kpis/sections/nrOfReplications";
import FordNextPhase from "modules/reporting/fordReports/kpis/sections/nextPhaseChange";
import FordKPIsActiveFilters from "modules/reporting/fordReports/kpis/filters/activeFilters";

const FordKPIsSections = () => {
  const {
    fordDashboardReducer: { kpisReducer }
  } = useSelector((state) => state);

  return (
    <>
      <FordKPIsActiveFilters filters={kpisReducer.filters} />
      <div className="row mb-2">
        <div className="col-8 pr-1">
          <FordNrOfProjectsStages nrOfProjectsStages={kpisReducer.nrOfProjectsStages} filters={kpisReducer.filters} />
        </div>
        <div className="col-4 pl-1">
          <FordProjectNumbers nrsData={kpisReducer.nrsData} filters={kpisReducer.filters} />
        </div>
      </div>
      <div className="row mb-5">
        <div className="col-8 pr-1">
          <div className="row">
            <div className="col-4 pr-1">
              <FordClientPlants clientPlants={kpisReducer.clientPlants} filters={kpisReducer.filters} />
            </div>
            <div className="col-4 pr-1 pl-1">
              <FordInnovationCategory innovationCategory={kpisReducer.innovationCategory} filters={kpisReducer.filters} />
            </div>
            <div className="col-4 pl-1">
              <FordNextPhase nextPhaseChange={kpisReducer.nextPhaseChange} filters={kpisReducer.filters} />
            </div>
          </div>
        </div>
        <div className="col-4 pl-1">
          <FordNrOfReplications nrOfReplications={kpisReducer.nrOfReplications} filters={kpisReducer.filters} />
        </div>
      </div>
    </>
  );
};

export default React.memo(FordKPIsSections);
